import { Component } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { ColDef } from 'ag-grid-community';
import { DateFilterComponent } from '../../shared/components/date-filter/date-filter.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExcelService } from '../../shared/services/excel.service';
import { DateService } from '../../shared/services/date.service';

@Component({
  standalone: false,
  selector: 'app-ledgers',
  templateUrl: './ledgers.component.html',
  styleUrl: './ledgers.component.scss'
})
export class LedgersComponent {

  count = 0;
  showDateFilter = false;
  apiUrl: any;
  gridApi: any;
  selectedFromDate: any = null;
  selectedToDate: any = null;

  ngbDateToEpoch(date: any): number | null {
    if (!date || !date.year || !date.month || !date.day) return null;
    return new Date(date.year, date.month - 1, date.day).getTime();
  }
  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };

  columnDefs: ColDef[] = [
    {
      headerName: 'Transaction Id',
      field: 'transactionId._id',
      editable: false,
      filter: false,
      valueFormatter: (params) => {
        return params.value ? params.value.toString().slice(-8).toUpperCase() : (params.data?._id ? params.data._id.toString().slice(-8).toUpperCase() : '');
      }
    },
    {
      headerName: 'Type',
      field: 'transactionType',
      editable: false,
      filter: false,
    },
    {
      headerName: 'Source Bank',
      field: 'sourceBank',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Source Account',
      field: 'sourceAccount',
      editable: false,
      filter: false,
    },
    {
      headerName: 'Destination Bank',
      field: 'destinationBank',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Destination Account',
      field: 'destinationAccount',
      editable: false,
      filter: false,
    },
    {
      headerName: 'Currency',
      field: 'currency',
      editable: false,
      filter: false,
    },
    {
      headerName: 'Amount',
      field: 'amount',
      editable: false,
      filter: false,
      valueFormatter: (params) => {
        return params.value != null ? Number(params.value).toFixed(2) : '';
      }
    },
  ];

  active = 1;

  constructor(private _api: ApiService,
    private _excelService: ExcelService,
    private _dateService: DateService
  ) {
  }

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    vm.gridApi.sizeColumnsToFit();
  }


  onSelectDate() {
    const vm = this;
    vm.showDateFilter = !vm.showDateFilter;
  }

  onDateSelected(result: any) {
    const vm = this;
    vm.selectedFromDate = result.fromDate;
    vm.selectedToDate = result.toDate;
    if (!vm.selectedFromDate && !vm.selectedToDate) {
      vm.showDateFilter = false;
    } else {
      // console.log(vm.selectedFromDate, vm.selectedToDate, 'sdates');
    }
    if (vm.selectedFromDate || vm.selectedToDate) {
      vm.showDateFilter = false;
    }
    vm.gridApi.refreshInfiniteCache();
  }


  onDownloadExcel() {
    const vm = this;
    let downloadUrl = '/admin/ledger/?_page=1&_limit=500';
    if (vm.selectedFromDate && vm.selectedToDate) {
      const fromEpoch = vm.ngbDateToEpoch(vm.selectedFromDate);
      const toEpoch = vm.ngbDateToEpoch(vm.selectedToDate);
      if (fromEpoch && toEpoch) {
        downloadUrl += '&createdAtdatePickerRange=' + fromEpoch + ',' + toEpoch;
      }
    }
    if (this.active === 2) {
      downloadUrl += '&transactionType_like=PTAMT';
    } else if (this.active === 3) {
      downloadUrl += '&transactionType_eq=PTCA';
    } else if (this.active === 4) {
      downloadUrl += '&transactionType_like=PTCAC';
    }
    vm._api.getData(downloadUrl).subscribe((res: any) => {
      if (res && !res.error && res.data.length > 0) {
        const exportData = res.data.map((row) => ({
          'Transaction Id': row.transactionId?._id || row._id || '',
          'Type': row.transactionType || '',
          'Source_Bank': row.sourceBank || '',
          'Source_Account': row.sourceAccount || '',
          'Destination_Bank': row.destinationBank || '',
          'Destination_Account': row.destinationAccount || '',
          'Currency': row.currency || '',
          'Amount': row.amount != null ? Number(row.amount).toFixed(2) : ''
        }));
        vm._excelService.exportAsExcelFile(exportData, 'Ledgers');
      }
    });
  }

  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;

        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        this.apiUrl = '/admin/ledger/' + '?_page=' + request._page + '&_limit=' + request._limit;
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(k => {
          if (k && filterData[k]) {
            vm.apiUrl = vm.apiUrl + '&' + k + '_like=' + filterData[k].filter;
          }
        });

        if (this.active === 2) {
          this.apiUrl = this.apiUrl + '&transactionType_like=PTAMT';
        } else if (this.active === 3) {
          this.apiUrl = this.apiUrl + '&transactionType_eq=PTCA';
        } else if (this.active === 4) {
          this.apiUrl = this.apiUrl + '&transactionType_like=PTCAC';
        }

        if (vm.selectedFromDate && vm.selectedToDate) {
          const fromEpoch = vm.ngbDateToEpoch(vm.selectedFromDate);
          const toEpoch = vm.ngbDateToEpoch(vm.selectedToDate);
          if (fromEpoch && toEpoch) {
            vm.apiUrl += '&createdAtdatePickerRange=' + fromEpoch + ',' + toEpoch;
          }
        }
        // console.log(vm.apiUrl);
        vm._api.getData(vm.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            vm.count = res.count;
            // console.log(vm.count);
            // console.log(res);
            params.successCallback(res.data, res.count);
            //vm.gridApi.sizeColumnsToFit();
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

}
